import { featureList } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function Features() {
  return (
    <section id="features" className="w-full bg-background-50 px-4 md:px-6 py-16 md:py-24">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="本站能帮你什么"
          title="先弄清楚分类逻辑，再决定读什么"
          desc="漫蛙不是一份随手堆起来的榜单，而是把「体系 — 画风 — 题材」三层信息拆开讲清楚。你只需要判断自己更看重哪一层，就能顺着线索找到方向。"
        />

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featureList.map((item, idx) => (
            <article
              key={item.title}
              className="group rounded-lg border border-background-200 bg-background-100/70 p-5 md:p-6 hover:border-primary-300 transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="w-12 h-12 rounded-lg flex items-center justify-center bg-primary-100 text-primary-700">
                  <i className={`${item.icon} text-2xl`}></i>
                </span>
                <span className="font-heading text-2xl font-bold text-background-300">
                  0{idx + 1}
                </span>
              </div>
              <h3 className="mt-5 font-heading text-base md:text-lg font-bold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}